import { Users } from "@phosphor-icons/react";
import { SLIDE_RIGHT, motion, stagger } from "./constants";

export default function RecentClientsCard({ clients, onNavigate }) {
  return (
    <div className="stat-card">
      <div className="flex items-center justify-between mb-4">
        <h3
          className="text-lg font-bold tracking-tight uppercase text-white"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          CLIENTI RECENTI
        </h3>
        <button
          onClick={() => onNavigate("/clients")}
          className="text-[#007AFF] text-sm hover:text-[#3395FF] transition-colors font-medium"
          data-testid="view-all-clients"
        >
          Vedi tutti
        </button>
      </div>

      {clients?.length > 0 ? (
        <div className="space-y-2">
          {clients.map((client, i) => (
            <motion.div
              key={client.id}
              {...SLIDE_RIGHT}
              transition={stagger(0.3, 0.08, i)}
              onClick={() => onNavigate(`/clients/${client.id}`)}
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-[#1A1A1A] cursor-pointer transition-colors group"
              data-testid={`recent-client-${i}`}
            >
              <div className="w-9 h-9 rounded-full bg-[#007AFF]/20 flex items-center justify-center text-[#007AFF] text-sm font-bold flex-shrink-0">
                {client.first_name?.charAt(0)?.toUpperCase()}
                {client.last_name?.charAt(0)?.toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate group-hover:text-[#007AFF] transition-colors">
                  {client.first_name} {client.last_name}
                </p>
                <p className="text-xs text-zinc-500">{client.objectives || "Nessun obiettivo"}</p>
              </div>
              {client.weight_kg && <span className="text-xs text-zinc-500">{client.weight_kg} kg</span>}
            </motion.div>
          ))}
        </div>
      ) : (
        <div className="text-center py-10">
          <Users size={36} weight="duotone" className="text-zinc-600 mx-auto mb-2" />
          <p className="text-zinc-500 text-sm">Nessun cliente ancora</p>
          <button
            onClick={() => onNavigate("/clients")}
            className="mt-2 text-[#007AFF] text-sm hover:text-[#3395FF] transition-colors"
            data-testid="add-first-client"
          >
            Aggiungi il tuo primo cliente
          </button>
        </div>
      )}
    </div>
  );
}
